// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhr_jk","CommentListPlaceholder--Legacy":"ih_b bhr_rc bhr_wq"};